export default __webpack_public_path__ + "static/mizuho-5c39b90ede04094eb20b8c65cadf2eae.png";